import { useSelector } from "react-redux";
import Navbar from "../../components/navbar";
import SkeletonCard from "../../components/skeletonCampaignCard";
import { useCampaignList } from "../reuseableEffects";
import CampaignCard from "./reuseableComponents/campaignCard";
import Footer from "../../components/footer";
import Spinner from "../../components/Spinners/Spinner";
import CompletedCampaignCard from "./reuseableComponents/completedCampaignCard";
import Input from "../../components/input";
import { useState } from "react";

const CompletedCampaigns = () => {
  const loading = useSelector((state) => state.user.loading);
  const campaignList = useCampaignList();
  const completedCampaigns = campaignList.filter(campaign => campaign.admin_status === "4");
  const [searchCampaign, setSearchCampaign] = useState("");

  const handleSearchCampaign = (event) => {
    setSearchCampaign(event.target.value);
  };

  const campaignImageURL =
    "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";

  return (
    <div className="grid min-h-screen content-between">
      <Spinner loading={useSelector((state) => state.user).loading} />
      <Navbar />
      <div className="mt-24 pb-16">
        {loading ? (
          <SkeletonCard />
        ) : (
          <div className="py-4 px-4 md:px-12 grid gap-4">
            <p className="font-semibold text-sm ubuntu-font">
              Completed campaigns:
            </p>
            <div className="w-full md:w-1/2 lg:w-1/3">
        <Input
          type={"search"}
          label={"Search campaign"}
          placeholder={"Enter campaign name..."}
          value={searchCampaign}
          onChange={handleSearchCampaign}
        />
      </div>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-10">
              {completedCampaigns.filter((row) => row.title.toLowerCase().includes(searchCampaign.toLowerCase()) || row.lastname.toLowerCase().includes(searchCampaign.toLowerCase())).map((row, index) => {
                const formattedAmountRaised = parseFloat(row?.amount_raise?.replace(/,/g, "")) || 0;
                const formattedAmount = parseFloat(row?.amount?.replace(/,/g, "")) || 0;
                const progress =
                  formattedAmount > 0
                      ? `${(
                          (formattedAmountRaised / formattedAmount) *
                          100
                        ).toFixed(2)}%`
                      : "0%";
                return (
                  <CompletedCampaignCard
                    key={index}
                    campaignImage={
                      campaignImageURL + (row?.image || "default-image.png")
                    }
                    campaignID={row?.CampaignID}
                    campaignTitle={row?.title}
                    campaignOwnerFirstName={row?.firstname}
                    campaignOwnerLastName={row?.lastname}
                    amountRaised={row?.amount_raise}
                    campaignGoal={row?.amount}
                    category={row?.category}
                    progress={progress}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CompletedCampaigns;
